import { environment } from "../../environments/environment";

const BASE_URL = environment.BASE_URL;
const BASE_URL_V2 = environment.BASE_URL_V2;
const WEB_SOCKET = environment.WEB_SOCKET


export const ROUTES = {
  WEB_SOCKET: `${WEB_SOCKET}`,
  SIGNIN: `${BASE_URL}` + '/auth/signin',
  SIGNUP: `${BASE_URL}` + '/auth/new-user-details',
  FORGOT_PASS_SEND_CODE: `${BASE_URL}` + '/auth/send-verification-code',
  FORGOT_PASS_VERIFY_CODE: `${BASE_URL}` + '/auth/verify-reset-password',
  SEND_EMAIL_OTP: `${BASE_URL}` + '/auth/verification/email/send-code',
  VERIFY_EMAIL_OTP: `${BASE_URL}` + '/auth/verify-email/verify-code',
  SEND_MOBILE_OTP: `${BASE_URL}` + '/auth/verification/mobile/send-code',
  VERIFY_MOBILE_OTP: `${BASE_URL}` + '/auth/verify-mobile/verify-code',
  VERIFY_SIGNUP: `${BASE_URL}` + '/auth/register-user',
  UPDATE_MEMBER: `${BASE_URL}` + '/specificMember/{memId}',
  PRINT_AND_MONITOR_FULL_DATA: `${BASE_URL}` + '/reports/superadminAggregate',
  PRINT_AND_MONITOR_FULL_DATA_ALL_COUNTRY: `${BASE_URL}` + '/stateWise-count',
  REPORTS_FULL_DATA_ALL_COUNTRY: `${BASE_URL_V2}` + '/stateWise-count',
  STAGNANT_REPORT: `${BASE_URL}` + '/reports/fetchStagnantReport',
  PRINT_AND_MONITOR_MEMBERS: `${BASE_URL}` + '/print/members',
  STAGNANT_MEMBERS: `${BASE_URL}/fetchStagnantData`,
  WISHLIST_USERS: `${BASE_URL}/fetchAllWishlistUsers`,
  MANAGE_USER: `${BASE_URL}` + '/users',
  MANAGE_USER_NEW: `${BASE_URL}` + '/usersNew',
  MANAGE_USER_DETAILS: `${BASE_URL}` + '/user/manage',
  DEFAULTER_LIST_DATA: `${BASE_URL}` + '/touchlists/details/{pageNo}',
  UPDATE_SPECIFIC_MEMBER: `${BASE_URL}` + '/members/{memId}',
  INACTIVE_REASON: `${BASE_URL}` + '/reasons/inactive',
  GLOBAL_SEARCH:
    `${BASE_URL}` +
    '/search/members/global/withsearchkey/{searchName}/{pageNo}/{pageSize}',
  KEYWORD_SEARCH: `${BASE_URL}` + '/search/members/global/withcriteria',
  GLOBAL_SEARCH_SL_DETAILS: `${BASE_URL}` + '/globalSearch/{memKey}',
  PINCODE_DETAILS: `${BASE_URL}` + '/common/pincodes/{pincode}',
  MEMBER_SEARCH: `${BASE_URL_V2}` + '/membersSearch',
  NAME_SEARCH: `${BASE_URL}` + '/searchMembers',
  REPORT_STATUS: `${BASE_URL}` + '/reports/statuses',
  LAST_REFRESH_DATE: `${BASE_URL}` + '/reports/refresh-date',
  UPDATED_DATA: `${BASE_URL}` + '/members/updated',
  SL_NO_MERGE_DATA: `${BASE_URL}` + '/member/memKey/merge-review-pending-count',
  SL_NO_MERGE_LIST: `${BASE_URL}` + '/member/memKey/merge-review-pending-list',
  MULTI_STATE_DATA: `${BASE_URL}` + '/reviews-pending',
  MERGE_REVIEW_DATA: `${BASE_URL}` + '/members/merged-family-codes-review',
  MERGE_REVIEW_DATA_BY_SLNO:
    `${BASE_URL}` + '/members/merged-family-codes/{memKey}',
  SL_NO_MERGE_REVIEW_DATA:
    `${BASE_URL}` + '/member/memKey/merge-review-details',
  SL_NO_MERGE_STATUS: `${BASE_URL}/member/memKey/merge-review`,
  WORK_HIS_MERGE_FC: `${BASE_URL}` + '/merge-fc-details',
  UPDATE_CYCLE: `${BASE_URL}` + '/trail',
  ARE_YOU_UPDATED: `${BASE_URL}` + '/members/family-members-updated',
  FC_INFO: `${BASE_URL}` + '/check/fc/details',
  NAMES_TO_UPDATE: `${BASE_URL}` + '/members/phil-data',
  FW_NAMES: `${BASE_URL}` + '/members/fw-names-assign',
  FW_NAMES_DPNF: `${BASE_URL}` + '/dpnf/fetchOtherUsers',
  FW_NAMES_REVIEW: `${BASE_URL}` + '/members/fw-names',
  DA_NAMES_REVIEW: `${BASE_URL}` + '/members/da-names',
  ASSIGN_DATA: `${BASE_URL}` + '/members/assign-data',
  EDIT_DETAILS: `${BASE_URL}` + '/phil-op/phil-not-updated/{memCode}',
  DPNF_LIST: `${BASE_URL}` + '/dpnf/member-not-found',
  MY_DPNF_LIST: `${BASE_URL}` + '/dpnf/fetch-my-dpnf-list',
  OTHERS_DPNF_LIST: `${BASE_URL}` + '/dpnf/fetch-others-dpnf-list',
  DELETE_DPNF: `${BASE_URL}` + '/reporter-feedback',
  DPNF_STATUS: `${BASE_URL}` + '/dpnf/nf-status',
  PINCODE: `${BASE_URL}` + '/common/pincodes/{pincode}',
  PINCODE_V2: `${BASE_URL_V2}` + '/common/pincodes/{pincode}',
  PINCODE_FOREIGN: `${BASE_URL}` + '/foreign/postal/details',
  RITWIK_LIST: `${BASE_URL}` + '/ritwiks/{id}',
  RITWIK_LIST_V2: `${BASE_URL_V2}` + '/ritwiks/{id}',
  SURNAME: `${BASE_URL}` + '/member/surnames',
  FC: `${BASE_URL}` + '/verifyMembers/{fcode}',
  FC_SIGNIN: `${BASE_URL}` + '/familyCodeDetails/{fcode}',
  STATE_LIST: `${BASE_URL}` + '/print/states',
  STATE_LIST_FOREIGN: `${BASE_URL}` + '/foreign/states',
  ADDRESS_ATTRIBUTE: `${BASE_URL}` + '/address/attribute',
  DASHBOARD_LEADERBOARD: `${BASE_URL}` + '/reports/leaderBoard',
  DASHBOARD_LEADERBOARD_DETAILS: `${BASE_URL}` + '/reports/leaderBoard/details',
  MY_STATS: `${BASE_URL}` + '/reports/fwUpdateStats',
  DISTRICT_LIST: `${BASE_URL}` + '/print/districts/',
  DISTRICT_LIST_FOREIGN: `${BASE_URL}` + '/foreign/districts',
  FD_MIGRATE: `${BASE_URL}` + '/phil-op/migrate',
  VERIFY_FC: `${BASE_URL}` + '/dpnf-status/{memberKey}',
  ADD_DPNF: `${BASE_URL}` + '/dpnf/member-not-found',
  FOUND_BY_USER: `${BASE_URL}` + '/dpnf-fw-updatedby',
  FIND_DETAILS: `${BASE_URL}` + '/members/assign-data',
  NOT_FOUND_MEMBER: `${BASE_URL}` + '/phil-op/phil-untrackable-data',
  WISHLISTS: `${BASE_URL}` + '/wishlists',
  WISHLISTSNAME: `${BASE_URL}/fetchWishlists`,
  CREATE_WISHLIST: `${BASE_URL}/createWishlist`,
  UPDATE_WISHLIST: `${BASE_URL}/updateWishlistName`,
  REACH_WISHLISTS: `${BASE_URL}` + '/touchlists/wishlist',
  ADD_REACH_WISHLIST: `${BASE_URL}` + '/touchlists/wishlist',
  NON_INITIATED: `${BASE_URL}` + '/phil-op/not-initiated/{memberCode}',
  USER_WISHLIST: `${BASE_URL}` + '/wishlists/{wishlistId}/members',
  USER_WISHLIST_DETAILS: `${BASE_URL}/fetchWishlistItems`,
  REACH_USER_WISHLIST: `${BASE_URL}` + '/touchlists/wishlist-data/{id}',
  // SHOW_PHN_NUMBER: `${BASE_URL}` + '/members/active-member-contact',
  SHOW_PHN_NUMBER: `${BASE_URL}` + '/members/member-contact',
  SHOW_PHN_NUMBER_ARE_YOU_UPDATED: `${BASE_URL}` + '/members/access-contact-number',
  SHOW_PHN_NUMBER_PM: `${BASE_URL}` + '/members/active-member-contact',
  REACH_PENDING_DATA: `${BASE_URL}` + '/touchlists/details/{pageNo}',
  REACH_MARK_AS_EXPIRED: `${BASE_URL}` + '/defaulter/add-info/{id}',
  ADD_REACH_DETAILS: `${BASE_URL}` + '/defaulter/add-info/{id}',
  EDIT_REACH_DETAILS: `${BASE_URL}` + '/defaulter/update-info/{memKey}/{id}',
  GET_REACH_NOTE_DETAILS: `${BASE_URL}` + '/defaulter/get-infos/{id}',
  PHASE_ONE_REPORT: `${BASE_URL}` + '/reports/phil-data/area-wise',
  PHASE_TWO_REPORT: `${BASE_URL}` + '/reports/phil-wishlist-report/user-wise',
  REJECTION_REPORT: `${BASE_URL}` + '/reports/fetchRejectedReport',
  REJECTION_REPORT_USERWISE: `${BASE_URL}` + '/members/fetchRejectedDetailsData',
  REACH_ADD: `${BASE_URL}` + '/touchlist/new',
  ADD_ITEM_TO_WISHLIST: `${BASE_URL}` + '/wishlists/{wishlistId}/members',
  ADD_TO_WISHLIST: `${BASE_URL}/addToWishlist`,
  TRANSFER_WISHLIST: `${BASE_URL}` + '/transfer-wishlist',
  ADD_DATA_IN_REACH_WL: `${BASE_URL}` + '/touchlists/wishlist-data',
  REJECTION: `${BASE_URL}` + '/members/updated/{memCode}',
  DEFAULTER_LIST: `${BASE_URL}` + '/ivLogs',
  DEFAULTER_LIST_NEW: `${BASE_URL}` + '/touchlist/details/{pageNo}',
  REFRESH_TOKEN: `${BASE_URL}` + '/auth/refresh_token',
  UPDATE_SERIAL_NO: `${BASE_URL}` + '/phil-op/phil-not-updated/{memCode}',
  REQUESTED_WISHLIST: `${BASE_URL}` + '/requested-wishlists',
  ACCEPT_WISHLIST: `${BASE_URL}` + '/accept-wishlist/{wishlistId}',
  REJECT_WISHLIST: `${BASE_URL}` + '/reject-wishlist/{wishlistId}',
  REMOVE_DPNF: `${BASE_URL}` + '/dpnf/member-not-found',
  EDIT_REACH_WISHLIST: `${BASE_URL}` + '/touchlists/wishlist/{id}',
  EDIT_WISHLIST: `${BASE_URL}` + '/wishlists/{id}',
  DELETE_PM_WISHLIST_DATA: `${BASE_URL}` + '/wishlists/{id}/members/{memberId}',
  DELETE_REACH_WISHLIST: `${BASE_URL}` + '/touchlists/wishlist/{wishlistId}',
  DELETE_WISHLIST: `${BASE_URL}` + '/wishlists/{wishlistId}',
  DELETE_WISHLIST_NAME: `${BASE_URL}/deleteWishlist`,
  DELETE_WISHLIST_ITEM: `${BASE_URL}/deleteWishlistItem`,
  DELETE_DATA_WISHLIST: `${BASE_URL}` + '/touchlists/wishlist-data/{id}',
  REACH_ADD_FAV: `${BASE_URL}` + '/touchlists/favourites',
  REACH_DELETE_DATA_FAV: `${BASE_URL}` + '/touchlists/favourites/{memKey}',
  REACH_GET_FAV_DATA: `${BASE_URL}` + '/touchlists/favourites',
  GET_STATUS_RESOLVER: `${BASE_URL}` + '/reports/statuses',
  PRINT_AND_MONITOR_ADD_FAV: `${BASE_URL}` + '/favourites/me/members',
  PRINT_AND_MONITOR_DEL_FAV: `${BASE_URL}` + '/favourites/me/members/{member}',
  FIND_DETAILS_ADD_FAV: `${BASE_URL}` + '/phil/favourites',
  FC_MERGE_BY_SL: `${BASE_URL}` + '/members/merge-family-code/{memKey}',
  FC_FOR_MERGE: `${BASE_URL}` + '/philFamilyMembers/{fcode}',
  ADD_FOR_MERGE: `${BASE_URL}` + '/members/merge-family-code/{memKey}',
  NOT_FOUND: `${BASE_URL}` + '/phil-op/not-trackable/{memberCode}',
  DELETE_USER_WISHLIST:
    `${BASE_URL}` + '/wishlists/{wishlistId}/members/{memberCode}',
  DELETE_FAVORITES_USER_WISHLIST:
    `${BASE_URL}` + '/phil/favourites/{memberCode}',
  FAVOURITES: `${BASE_URL}` + '/phil/favourites',
  MERGE_HISTORY: `${BASE_URL}` + '/merge-fc-details',
  PROFILE_DATA: `${BASE_URL}` + '/profile',
  PROFILE_PIC: `${BASE_URL}` + '/user/profile-pic',
  DETAILS_BASED_ON_SLNO: `${BASE_URL}` + '/members/updated-details/{memkey}',
  DA_MERGE_STATUS: `${BASE_URL}` + '/members/merge-family-code/{memKey}',
  MERGE_PENDING_DATA: `${BASE_URL}` + '/merge-fc-reviews-pending',
  WORK_HISTORY_UPDATED: `${BASE_URL}` + '/history/me',
  WORK_HISTORY_UPDATED_REJECTED: `${BASE_URL}` + '/members/update_history',
  WORK_HISTORY_UPDATED_DA: `${BASE_URL}` + '/members/initial-review-history',
  WORK_HISTORY_UPDATED_SU: `${BASE_URL}` + '/members/final-review-history',
  WORK_HISTORY_MERGED: `${BASE_URL}` + '/members/update_history',
  PINCODES_FOR_STATE_DISTRICT:
    `${BASE_URL}` + '/common/print/pincodes/{state_name}/{district_name}',
  OBLATE_DATA: `${BASE_URL}` + '/ritwiks/me/oblates',
  OBLATE_COUNT: `${BASE_URL}` + '/ritwiks/me/oblatecounts',
  OBLATE_NO_OF_WORKING: `${BASE_URL}` + '/ritwiks/me/activity',
  ADD_NEW_OBLATE: `${BASE_URL}` + '/add/new/oblate',
  PICK_USER: `${BASE_URL}` + '/phil-op/user-pickings/{memId}',
  PICK_USER_ACTION: `${BASE_URL}` + '/phil-op/user-actions/{memId}',
  REVIEW_CHECK: `${BASE_URL}` + '/skipped-members',
  REVIEW_RESET: `${BASE_URL}` + '/members/reset/{memKey}',
  PHASE_TWO_WISHLIST: `${BASE_URL}` + '/phil/wishlists/{id}',
  USER_MANAGE_LEVELS: `${BASE_URL}` + '/userManageLevels',
  USER_ROLE_LOCATIONS: `${BASE_URL}` + '/userRoleLocation',
  USER_ROLE_PERMISSIONS: `${BASE_URL}` + '/userRolePermission',
  WORKER_ROLE_LIST: `${BASE_URL}` + '/workerRoles',
  USER_RESET_FC: `${BASE_URL}` + '/resetUserVerification',
  USER_NEW_ROLE: `${BASE_URL}` + '/addNewRole',
  USER_REMOVE_ROLE: `${BASE_URL}` + '/removeExistingRole',
  POINT_OF_CONTACT_URL: `${BASE_URL}/members/poc`,
  REACH_REPORT: `${BASE_URL}/reports/reach`,
  STAGNANT_WISHLIST_REPORT: `${BASE_URL}/stagnant/wishlist/report`,
  WORKER_LIST: `${BASE_URL}/members/worker-list`,
  ALL_WORKER_LIST: `${BASE_URL}/workers/{id}`,
  USER_LOC: `${BASE_URL}/auth/user-loc`,
  STAGNANT_EDIT: `${BASE_URL}/member/user-notes`,
  SAVE_FCM_TOKEN: `${BASE_URL}/notification/saveFcmToken`,
  wORKER_REPORT: `${BASE_URL}/ritwiks/oblate-statistics`,
  LANGUAGE_LIST: `${BASE_URL}/common/language-codes`,
  WORKER_CERT: `${BASE_URL}/common/worker-cert/content`,
  WORKER_NAME_FC: `${BASE_URL}/diksha-patra/workers`,
  RECEIVING_COUNT: `${BASE_URL}/receiving/count`,
  RECEIVING_REPORT: `${BASE_URL}/receiving/lot/details`,
  WORKER_DETAILS: `${BASE_URL}/worker-details/{fc}`,
  DP_1_0_DETAILS: `${BASE_URL}/phaseOne/fetch-data`,
  DP_1_0_STATES: `${BASE_URL}/phaseOne/states`,
  DP_1_0_ASSIGN: `${BASE_URL}/phaseOne/assign-data/{memKey}`,
  DP_1_0_ADDRESS_ATTRIBUTE: `${BASE_URL}/phaseOne/address/attribute`,
  STAGNANT_STATUS: `${BASE_URL}/checkStagnantStatus`,
  WISHLIST_CONTRIBUTERS: `${BASE_URL}/fetchContributersOfWishlist`,
  //visit urls
  ACCESS_VISITED_CONTACT: `${BASE_URL}/accessVisitedContact`,
  FETCH_VISITED_USERS: `${BASE_URL}/fetchVistedUsers`,
  FETCH_CATEGORIES: `${BASE_URL}/fetchCategories`,
  FETCH_VISIT_DATA: `${BASE_URL}/fetchVisitData`,
  FETCH_VISIT_HISTORY: `${BASE_URL}/fetchVisitHistory`,
  ADD_VISIT_DATA: `${BASE_URL}/addVisitData`,
  UPDATE_VISIT_DATA: `${BASE_URL}/updateVisitData`,
  OBLATE_REPORT: `${BASE_URL}/oblate/report`,
  NEW_SEND_MOBILE_OTP: `${BASE_URL}/user/verification/mobile/send-code`,
  NEW_VERIFY_MOBILE_OTP: `${BASE_URL}/user/verification/mobile/verify-code`,
  NEW_SEND_EMAIL_OTP: `${BASE_URL}/user/verification/email/send-code`,
  NEW_VERIFY_EMAIL_OTP: `${BASE_URL}/user/verification/email/verify-code`,
  UPDATE_PROFILE: `${BASE_URL}/profile`,
  OBLATE_ADD_LOTINFO: `${BASE_URL}/oblate/lot/add`,
  OBLATE_FETCH_LOTCOUNT: `${BASE_URL}/oblate/lot/details`,
  SAVE_ID_PROOF_DETAILS: `${BASE_URL}/upload/member/doc`,
  UPDATE_ID_PROOF_DETAILS: `${BASE_URL}/member/doc/update`,
  FETCH_WISHLIST_ITEM: `${BASE_URL}/phil/wishlistItems`,
  FETCH_USER_WISHLIST_ITEM: `${BASE_URL}/phil/user-wishlists`,
  FETCH_VISIT_REPORT: `${BASE_URL}/reports/visit`,
  FETCH_RITWIKI_BALANCE: `${BASE_URL}/member/ritwiki/balance`,
  FETCH_RITWIKI_PREVIOUS_REQS: `${BASE_URL}/member/ritwiki/prevRequests`,
  FETCH_RITWIKI_RECENT_ACTIVITY: `${BASE_URL}/member/ritwiki/activities`,
  RITWIKI_WITHDRAW: `${BASE_URL}/member/ritwiki/withdraw`,
  FETCH_PRVRT_BALANCE: `${BASE_URL}/member/prvrt/balance`,
  FETCH_PRVRT_PREVIOUS_REQS: `${BASE_URL}/member/prvrt/prevRequests`,
  FETCH_PRVRT_RECENT_ACTIVITY: `${BASE_URL}/member/prvrt/activities`,
  PRVRT_WITHDRAW: `${BASE_URL}/member/prvrt/withdraw`,
  ADD_NEW_OBLATE_ONLINE: `${BASE_URL}` + '/add/new/oblate/online',
  ADD_NEW_OBLATE_OFFLINE: `${BASE_URL}` + '/add/new/oblate/offline',
  OBLATE_UPLOAD_DP_IMAGE: `${BASE_URL}` + '/oblate/upload/dp/image',
  OBLATE_OFFLINE_DRAFT_LIST: `${BASE_URL}/oblate/offline/draft/list`,
  OBLATE_OFFLINE_DRAFT_LIST_BY_ID: `${BASE_URL}/oblate/offline/draft/list/{memkey}`,
  OBLATE_UPDATE_OFFLINE_DATA_BY_ID: `${BASE_URL}/oblate/update/offline/data/{memkey}`,
  FETCH_OBLATE_DEVOTION_MEMBERS: `${BASE_URL}/members/phlData`,
  UPLOAD_DOCS_OBLATE_DEVOTION_MEMBERS: `${BASE_URL}/members/update/phlData`,
  OBLATE_COUNT_REPORT: `${BASE_URL}/reports/oblate/count`,
  OBLATE_LISTS: `${BASE_URL}/reports/oblate/list`,
  OBLATE_DAILY_COUNT: `${BASE_URL}/oblate/daily/count`,
  MEMBER_FC_N_CONTACT: `${BASE_URL}/members/contact/fc/details`,
  MEMBER_SHOW_CONTACT: `${BASE_URL}/members/contact`,
  DP_ENTRY_STATS: `${BASE_URL}/oblate/dp/entry/count`,
  BANGLADESH_1_O_ALL_DATA: `${BASE_URL}/phaseOne/report`,
  ADD_ACCOUNT: `${BASE_URL}/member/worker/bank/details`,
  PANJA_INFO: `${BASE_URL}/member/worker/panja/info`,
  PANJA_RENEWAL_INFO: `${BASE_URL}/member/worker/renewal/info`,
  RITWIK_REPORT: `${BASE_URL}/member/worker/ritwik/report`,
  BANK_STATS: `${BASE_URL}/phil/settlement/stats`,
  UNSETTLED_BANK_RECORDS: `${BASE_URL}/phil/settlement/unsettled-records`,
  GET_ALL_BANKS: `${BASE_URL}/phil/settlement/bank-accounts`,
  SETTLEMENT_DOCUMENT_UPLOAD: `${BASE_URL}/phil/settlement/upload-files`,
  USER_ACTIVITY_REPORT: `${BASE_URL}/reports/user/activity`,
  USER_ROLE_TYPES: `${BASE_URL}/reports/accessible/roles`,
  IV_DEPOSIT_REPORT: `${BASE_URL}/reports/IVDeposit`,
  UNSETTLED_MANDIR: `${BASE_URL}/eshtablishment/unsettled`,
  MANDIR_WORKER: `${BASE_URL}/eshtablishment/workers`,
  MANDIR_BILLS: `${BASE_URL}/eshtablishment/bills`,
  MANDIR_ADVANCE_TAKEN: `${BASE_URL}/eshtablishment/advance`,
};
